import './author.less'
import m from 'mithril'
import {classes, Picture} from '@codeurs/front'
import {Component, Icon} from '@codeurs/front'
import {AuthorType} from 'types/types'

export default class Author extends Component<{
	author: AuthorType
	class?: string
}> {
	view() {
		const {author, class: className} = this.attrs
		const img = author && author.image
		return (
			author &&
			m('.author', classes(className), [
				img &&
					m('.author-image',
						m(Picture, {
							fit: 'cover',
							...img
						})
					),
				author && m('.author-name', author.title)
			])
		)
	}
}
